import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/quadras4.jpg'


const _hoisted_1 = { class: "banner" }
const _hoisted_2 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "image" }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "Planos Sunset Arena Lavras"
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("h1", null, "ESCOLHA SEU PLANO", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("p", null, "Conheça os diferentes planos que oferecemos para aluguel de quadras. Temos opções que se encaixam perfeitamente no seu estilo de vida. Confira e escolha o melhor para você!", -1)),
      _createVNode(_component_router_link, { to: "/planosView" }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createElementVNode("button", null, "VER PLANOS", -1)
        ])),
        _: 1
      })
    ])
  ]))
}